import { createSelector } from "reselect";

const selectTanksState = (state) => state.tanks;

const selectAreas = () => createSelector(selectTanksState, (tanksState) => tanksState.areas);
const selectTanks = () => createSelector(selectTanksState, (tanksState) => tanksState.tanks);
const selectTanksFilter = () => createSelector(selectTanksState, (tanksState) => tanksState.filter);
const selectTanksOperations = () => createSelector(selectTanksState, (tanksState) => tanksState.operations);
const selectTanksOperationsFilter = () => createSelector(selectTanksState, (tanksState) => tanksState.operationsFilter);
const selectTanksStateOperations = () => createSelector(selectTanksState, (tanksState) => tanksState.tanksStateOperations);
const selectTanksStateOperationsFilter = () => createSelector(selectTanksState, (tanksState) => tanksState.tanksStateOperationsFilter);
const selectTanksOperationsByTankId = (tankId) => createSelector(selectTanksState, (tanksState) => {
    const tankOperations = tanksState.operations.filter((item) => item.tankId === tankId);
    return tankOperations;
})

export {
    selectAreas,
    selectTanks,
    selectTanksFilter,
    selectTanksOperations,
    selectTanksOperationsFilter,
    selectTanksStateOperations,
    selectTanksStateOperationsFilter,
    selectTanksOperationsByTankId
}